import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Box } from '@mui/material';
import { LanguageProvider, useLanguage } from './contexts/LanguageContext';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { ContentProvider } from './contexts/ContentContext';
import { ThemeProvider as MUIThemeProvider } from '@mui/material/styles';
import { lightTheme, darkTheme } from './theme';
import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact';
import WhyAlRasheed from './pages/WhyAlRasheed';
import PremiumLaptops from './pages/PremiumLaptops';
import Admin from './pages/Admin';
import './App.css';

const AppContent = () => {
  const { language } = useLanguage();
  const { theme } = useTheme();
  
  const baseTheme = theme === 'light' ? lightTheme : darkTheme;
  const themeWithDirection = {
    ...baseTheme,
    direction: language === 'ar' ? 'rtl' : 'ltr',
  };

  React.useEffect(() => {
    document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  return (
    <MUIThemeProvider theme={themeWithDirection}>
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/services" element={<Services />} />
              <Route path="/why-alrasheed" element={<WhyAlRasheed />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/premium-laptops" element={<PremiumLaptops />} />
              <Route path="/all-laptops" element={<PremiumLaptops />} />
              <Route path="/new-laptops" element={<PremiumLaptops />} />
              <Route path="/refurbished-laptops" element={<PremiumLaptops />} />
              <Route path="/used-laptops" element={<PremiumLaptops />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>
          </Box>
          <Footer />
          <WhatsAppButton />
        </Box>
      </Router>
    </MUIThemeProvider>
  );
};

function App() {
  return (
    <LanguageProvider>
      <ThemeProvider>
        <ContentProvider>
          <AppContent />
        </ContentProvider>
      </ThemeProvider>
    </LanguageProvider>
  );
}

export default App;
